export const formatTelefono = (raw) => {
  if (!raw) return "";
  const d = String(raw).replace(/\D/g, "");

  // México
  if (d.startsWith("52")) {
    const resto = d.slice(2);
    const conUno = resto.length === 11 && resto.startsWith("1");
    const nac = conUno ? resto.slice(1) : resto; // 10 dígitos nacionales
    if (nac.length === 10) {
      const area = nac.slice(0, 3);
      const p1 = nac.slice(3, 6);
      const p2 = nac.slice(6);
      return `+52 ${conUno ? "1 " : ""}(${area}) ${p1} ${p2}`;
    }
  }

  return `+${d}`;
};

export const mergeMensajes = (a = [], b = []) => {
  const mapa = new Map();
  for (const m of [...a, ...b]) {
    mapa.set(String(m._id || m.waMessageId), m);
  }
  return [...mapa.values()].sort((x, y) => {
    const ix = String(x._id || "");
    const iy = String(y._id || "");
    if (ix < iy) return -1;
    if (ix > iy) return 1;
    return 0;
  });
};

export const inicialesDe = (nombre) => {
  if (!nombre) return "";
  const palabras = String(nombre)
    .trim()
    .split(/\s+/)
    .filter((p) => p && /[a-záéíóúñ]/i.test(p[0]));
  if (!palabras.length) return "";
  return palabras
    .slice(0, 2)
    .map((p) => p[0].toUpperCase())
    .join("");
};

const PASTELES = [
  { fondo: "#FDE2E4", texto: "#9D4E57" },
  { fondo: "#E2F0CB", texto: "#5A7A2E" },
  { fondo: "#CDE7F0", texto: "#2D6C85" },
  { fondo: "#FFF1BA", texto: "#8A6D1F" },
  { fondo: "#E4DCF1", texto: "#5E4B8B" },
  { fondo: "#FFE0C7", texto: "#9A5A24" },
  { fondo: "#D4F0E8", texto: "#2E7D6B" },
  { fondo: "#F6D9EC", texto: "#8C3F72" },
  { fondo: "#DDEBF7", texto: "#3B5F85" },
  { fondo: "#FCE4C8", texto: "#91602A" },
  { fondo: "#E0F2E9", texto: "#357A5B" },
  { fondo: "#EDE0D4", texto: "#7A5B42" },
];

export const colorAvatar = (semilla) => {
  const s = String(semilla || "");
  if (!s) return PASTELES[0];
  let suma = 0;
  for (let i = 0; i < s.length; i += 1) suma = (suma * 31 + s.charCodeAt(i)) % 100000;
  return PASTELES[suma % PASTELES.length];
};
